import React from 'react';

export const ContainerTable = ({children}) => {
    return (
        <div className="flex-auto  py-10 pt-0">
            {children}
        </div>
    );
};


